import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { Flex } from '../shared/Flex';
import { useAlertColors } from './useAlertColors';
import { fontSize, fontWeight } from '../../style/tokens';

const Wrapper = styled(Flex)<{ bg: string; border: string }>`
  height: auto;
  min-width: 50%;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border: 2px solid ${({ border }) => border};
  border-radius: 8px;
  background: ${({ bg }) => bg};
  box-sizing: border-box;
`;

const Message = styled.div<{ color: string }>`
  padding: 5px 0 2px 0;
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.normal};
  font-family: inherit;
  color: ${({ color }) => color};
  text-align: center;
`;

const Solution = styled.div<{ color: string }>`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.normal};
  font-family: inherit;
  color: ${({ color }) => color};
  text-align: center;
`;

const Retry = styled.div<{ color: string }>`
  padding: 3px 0 5px 0;
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.normal};
  font-family: inherit;
  color: ${({ color }) => color};
  text-align: center;
`;

const ErrorAlert = ({ message, severity = 'Error', solution }: { message?: string; severity?: 'Warning' | 'Error'; solution?: string }) => {
  const { bg, border, textColor } = useAlertColors();
  const intl = useIntl();

  if (!message) {
    return null;
  }

  return (
    <Wrapper bg={bg} border={border}>
      <Message color={textColor}>{message}</Message>
      {solution && <Solution color={textColor}>{solution}</Solution>}
      <Retry color={textColor}>{intl.formatMessage({ id: 'alert.retryHint' })}</Retry>
    </Wrapper>
  );
};
export default ErrorAlert;
